import React from 'react'
import './Thanks.css'

const Thanks = () => (
  <div className='thanks'>
    <div className='thanks-inner'>
      <div className='thanks-section'>
        <h2 className='section-header'> Thanks for reaching out!</h2>
        <div className='section-content'>
          <p>I got your email and will get back to you as soon as possible.</p>
        </div>
      </div>
      <div className='thanks-section'>
        <div className='section-content'>
          <p>If you are too excited and can't wait to get your project started, feel free to call or text me at 859-913-0567.</p>
        </div>
      </div>
    </div>
  </div>
)


export default Thanks